import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as Common from "./CommonManager";
import DownloadIcon from "../img/Download_Icon.svg";
import { Dialog, DialogContent, DialogTitle, DialogActions } from "@material-ui/core";
import intl from "react-intl-universal";
import { NavDropdown } from "react-bootstrap";

class CloudProcessingBox extends Component {
    state = {
        isDownloadMenuOpen: false,
        showExpiredLinkDialog: false,
        expiredLinkMessage: intl.get("The_Download_Link_Has_Expired_Please_Refresh"),
    };
    
    downloadMenuRef = React.createRef();
    downloadButtonRef = React.createRef();
    
    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutsideDownloadMenu);
    }
    
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutsideDownloadMenu);
    }
    
    handleClickOutsideDownloadMenu = (e) => {
        if (!this.state.isDownloadMenuOpen) return;
    
        const menuEl = this.downloadMenuRef.current;
        const btnEl = this.downloadButtonRef.current;
    
        if (
            (menuEl && menuEl.contains(e.target)) ||
            (btnEl && btnEl.contains(e.target))
        ) {
            return;
        }
    
        this.setState({ isDownloadMenuOpen: false });
    };
    
    toggleDownloadMenu = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState((prev) => ({ isDownloadMenuOpen: !prev.isDownloadMenuOpen }));
    };
    
    closeDownloadMenu = () => {
        this.setState({ isDownloadMenuOpen: false });
    };

    isInitializingLike = () => {
        const s = (this.props.cloudProcessingData.PMAutomationStatus || '').toLowerCase();
        return s === 'initializing';
    };

    isRunning = () => {
        const s = (this.props.cloudProcessingData.PMAutomationStatus || '').toLowerCase();
        return s === 'running';
    };

    isCompleted = () => {
        const s = (this.props.cloudProcessingData.PMAutomationStatus || '').toLowerCase();
        return s === 'completed';
    };

    getCloud3dLabel = (inputParams) => {
        const buildType =
        inputParams && inputParams.buildType != null
            ? String(inputParams.buildType).toUpperCase()
            : "";
    
        if (buildType === "GS") return intl.get("Download_Gaussian_Splatting");
        if (buildType === "MESH") return intl.get("Download_Mesh");
        return null;
    };
    
    canShowCloud2d = (inputParams) => {
        return !!(inputParams && inputParams.orthoPhoto === true);
    };
    
    getCloud2dLabel = () => {
        return intl.get("Download_Ortophoto");
    };

    showRefreshPopup = () => {
        this.setState({ showExpiredLinkDialog: true, isDownloadMenuOpen: false });
    };
    
    handleCloseExpiredLinkDialog = () => {
        this.setState({ showExpiredLinkDialog: false });
    };
    
    handleRefreshPage = () => {
        window.location.reload();
    };
  
    render() {
        const { cloudProcessingData } = this.props;
        const inputParams = JSON.parse(cloudProcessingData.InputParams);
        const cloud2dLink = cloudProcessingData.Cloud2dDownloadLink;
        const cloud3dLink = cloudProcessingData.Cloud3dDownloadLink;
        const hasAnyDownloadLink = !!(cloud2dLink || cloud3dLink);
        const showCloud2d = !!(cloud2dLink && this.canShowCloud2d(inputParams));
        const cloud3dLabel = cloud3dLink ? this.getCloud3dLabel(inputParams) : null;
        const canViewResult =
            this.isCompleted() &&
            (!cloudProcessingData.EndpointID || (cloudProcessingData.Pod || '').toLowerCase() === 'p2c');

        const triggerDownload = async (url) => {
            try {
              const res = await fetch(url, {
                method: "HEAD",
                cache: "no-store",
                credentials: "omit",
              });

              if (!res.ok) {
                this.showRefreshPopup();
                return;
              }
          
              const a = document.createElement("a");
              a.href = url;
              a.target = "_blank";
              a.rel = "noreferrer";
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            } catch (err) {
              try {
                const a = document.createElement("a");
                a.href = url;
                a.target = "_blank";
                a.rel = "noreferrer";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              } catch {
                this.showRefreshPopup();
              }
            }
        };

        return (
            <React.Fragment>
                <section
                    className="cloudProcessingBlock"
                    style={
                        (cloudProcessingData.PMAutomationStatus !== null && (cloudProcessingData.PMAutomationStatus.toLowerCase() == 'initializing' || cloudProcessingData.PMAutomationStatus.toLowerCase() == 'running'))
                            ? { borderLeft: "10px solid #0186bc" }
                            : (cloudProcessingData.PMAutomationStatus !== null && cloudProcessingData.PMAutomationStatus.toLowerCase() == 'completed')
                                ? { borderLeft: "10px solid #1C8D17" }
                                : (cloudProcessingData.PMAutomationStatus !== null && (cloudProcessingData.PMAutomationStatus.toLowerCase() == 'failed' || cloudProcessingData.PMAutomationStatus.toLowerCase() == 'canceled'))
                                    ? { borderLeft: "10px solid #FA2323" }
                                    : { borderLeft: "10px solid white" }
                    }
                >
                    <div style={{ marginTop: '10px' }}>
                        <strong>{cloudProcessingData.UserIdentifier}</strong>
                    </div>

                    <div id="projectIdCloudProcessing">
                        <span style={{ fontSize: '13px' }}> Project ID:&nbsp;
                            <span>{cloudProcessingData.PMAutomationID}</span>
                        </span>

                        <span style={{ float: 'right', position: 'relative', bottom: '1px' }}>
                            {this.isCompleted() ? (
                                <span
                                style={{
                                    background: 'rgb(181, 239, 201)',
                                    color: 'rgb(28, 141, 23)',
                                    borderRadius: '999px',
                                    padding: '2px 10px',
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    lineHeight: '16px'
                                  }}
                                >
                                    Completed
                                </span>
                            ) : this.isInitializingLike() ? (
                                <span style={{ fontSize: '12px', color: '#666' }}>
                                    Initializing&nbsp;
                                    <i
                                        className="fa fa-spinner fa-spin"
                                        aria-hidden="true"
                                        style={{ color: '#0186bc' }}
                                    />
                                </span>
                            ) : this.isRunning() ? (
                                <span className='cloudProcessingBlockDetailsSpan' style={{ fontSize: '12px', color: '#666' }}>
                                    {cloudProcessingData.PMAutomationStatus}&nbsp;
                                    <i
                                        className="fa fa-spinner fa-spin"
                                        aria-hidden="true"
                                        style={{ color: '#0186bc' }}
                                    />
                                </span>
                            ) : (
                                <span className='cloudProcessingBlockDetailsSpan' style={{ fontSize: '12px', color: '#666' }}>
                                    {cloudProcessingData.PMAutomationStatus}
                                </span>
                            )}
                        </span>
                    </div>

                    <div className="cloudProcessingBlockDetails">
                        <span className='' id="cloudProcessingBlockDetailsSpanId" style={{ float: 'left' }}>
                            {cloudProcessingData.FilesCount} Photos{" "}
                            <span style={{ fontSize: '13px' }}>[{cloudProcessingData.GPRequestedValue.toFixed(2)} gigapixel]</span>
                        </span>

                        <span>
                            Start Date:&nbsp;
                            <strong>
                                <span>{new Date(cloudProcessingData.CreatedAt).toDateString()}</span>
                            </strong>
                        </span>

                        <span id="cloudProcessingBlockDetailsPackageID">
                            Package ID:&nbsp;
                            <strong>
                                <span>{cloudProcessingData.PackageID}</span>
                            </strong>
                        </span>

                        {(canViewResult || hasAnyDownloadLink) ? (
                            <span style={{ float: 'right', display: 'inline-flex', gap: '12px' }}>
                                <Link
                                    id="viewResultLinkId"
                                    target={"_blank"}
                                    style={{
                                        color: 'rgb(2, 134, 187)',
                                        textDecoration: 'none',
                                        fontWeight: 600,
                                        marginRight: hasAnyDownloadLink ? '30px' : '0px'
                                    }}
                                    to={"/gettingStarted?displayLogin=1&projectId=" + cloudProcessingData.Id + "&projectName=" + cloudProcessingData.UserIdentifier}
                                >
                                    View Result
                                </Link>
                                {hasAnyDownloadLink ?(
                                    <span style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
                                        <NavDropdown
                                            id="cloudProcessingDownloadMenu"
                                            alignRight
                                            title={
                                            <img
                                                src={DownloadIcon}
                                                alt="Download"
                                                style={{ width: "18px", height: "18px" }}
                                            />
                                            }
                                        >
                                            {showCloud2d ? (
                                            <NavDropdown.Item
                                                id="cloud2dDownloadItem"
                                                className="dropDownItemProductClass"
                                                onClick={async (e) => {
                                                e.preventDefault();
                                                await triggerDownload(cloud2dLink);
                                                }}
                                            >
                                                {this.getCloud2dLabel()}
                                            </NavDropdown.Item>
                                            ) : null}

                                            {cloud3dLabel ? (
                                            <NavDropdown.Item
                                                id="cloud3dDownloadItem"
                                                className="dropDownItemProductClass"
                                                onClick={async (e) => {
                                                e.preventDefault();
                                                await triggerDownload(cloud3dLink);
                                                }}
                                            >
                                                {cloud3dLabel}
                                            </NavDropdown.Item>
                                            ) : null}

                                            {!showCloud2d && !cloud3dLabel ? (
                                            <NavDropdown.Item
                                                id="noFilesDownloadItem"
                                                className="dropDownItemProductClass"
                                                disabled
                                            >
                                                No files available
                                            </NavDropdown.Item>
                                            ) : null}
                                        </NavDropdown>
                                    </span>
                                ):null}
                            </span>
                        ) : null}
                    </div>

                    {cloudProcessingData.OutputParams && Common.isValidNonEmptyJSON(cloudProcessingData.OutputParams)
                        ?
                        <div>
                            <table
                                className='tblOutputs'
                                style={{ width: "70%", textAlign: "center" }}
                            >
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: "center" }}>Name</th>
                                        <th style={{ textAlign: "center" }}>Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.keys(JSON.parse(cloudProcessingData.OutputParams)).map((key, index) => (
                                        <tr key={index}>
                                            <td>{key}</td>
                                            <td>{JSON.parse(cloudProcessingData.OutputParams)[key]}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        : null
                    }
                </section>
                <Dialog
                    open={this.state.showExpiredLinkDialog}
                    fullWidth
                    maxWidth={"sm"}
                    aria-labelledby="expired-link-dialog-title"
                    >
                    <DialogTitle
                        id="expired-link-dialog-title"
                        className="PropertySheetDialogTitle"
                    >
                        Download link expired
                    </DialogTitle>

                    <DialogContent>
                        <form className="mb-4">
                        <label className="mr-3">{this.state.expiredLinkMessage}</label>
                        </form>
                    </DialogContent>

                    <DialogActions>
                        <button
                        onClick={this.handleCloseExpiredLinkDialog}
                        className="btn btn-secondary btn-login text-capitalize mb-2 pl-4 pr-4 pt-1 pb-1"
                        color="primary"
                        >
                        Cancel
                        </button>

                        <button
                        onClick={this.handleRefreshPage}
                        className="btn btn-primary btn-login text-capitalize mb-2 pl-4 pr-4 pt-1 pb-1"
                        type="button"
                        autoFocus
                        >
                        Refresh
                        </button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        )
    }
}

export default CloudProcessingBox;
